import { render } from "./HeadingBlock.vue?vue&type=template&id=5dd66937"
import script from "./HeadingBlock.vue?vue&type=script&lang=js"
export * from "./HeadingBlock.vue?vue&type=script&lang=js"

import "./HeadingBlock.vue?vue&type=style&index=0&id=5dd66937&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__